export default __webpack_public_path__ + "739b98ff4ca3f5148c29e841025f9ff0.png";